import Chart from 'chart.js'
import { Doughnut, mixins } from 'vue-chartjs'
const { reactiveProp } = mixins

export default {
  extends: Doughnut,
  mixins: [reactiveProp],
  props: ['total'],
  methods: {
    update() {
      this.$data._chart.update()
    }
  },
  data() {
    return {
      options: {
        title: {
          display: false,
          text: 'Occupancy',
          fontSize: 16,
          fontFamily: 'Nunito',
          padding: 0
          // fontColor: 'white',
        },
        elements: {
          center: {
            text: '0 Units',
            color: '#38406a', //Default black
            fontStyle: 'Nunito', //Default Arial
            sidePadding: 25 //Default 20 (as a percentage)
          }
        },
        responsive: true,
        aspectRatio: 1,
        legend: {
          labels: {
            // fontColor: 'white'
            boxWidth: 15
          }
        },
        layout: {
          padding: {
            left: 5,
            right: 5,
            bottom: 5
          }
        }
      }
    }
  },
  mounted() {
    Chart.pluginService.register({
      beforeDraw: function (chart) {
        if (chart.config.options.elements.center) {
          //Get ctx from string
          var ctx = chart.chart.ctx

          //Get options from the center object in options
          var centerConfig = chart.config.options.elements.center
          var fontStyle = centerConfig.fontStyle || 'Arial'
          var txt = centerConfig.text
          var color = centerConfig.color || '#000'
          var sidePadding = centerConfig.sidePadding || 20
          var sidePaddingCalculated =
            (sidePadding / 100) * (chart.innerRadius * 2)
          //Start with a base font of 30px
          ctx.font = '40px ' + fontStyle

          //Get the width of the string and also the width of the element minus 10 to give it 5px side padding
          var stringWidth = ctx.measureText(txt).width
          var elementWidth = chart.innerRadius * 2 - sidePaddingCalculated

          // Find out how much the font can grow in width.
          var widthRatio = elementWidth / stringWidth
          var newFontSize = Math.floor(30 * widthRatio)
          var elementHeight = chart.innerRadius * 2

          // Pick a new font size so it will not be larger than the height of label.
          var fontSizeToUse = Math.min(newFontSize, elementHeight)

          //Set font settings to draw it correctly.
          ctx.textAlign = 'center'
          ctx.textBaseline = 'middle'
          var centerX = (chart.chartArea.left + chart.chartArea.right) / 2
          var centerY = (chart.chartArea.top + chart.chartArea.bottom) / 2
          ctx.font = fontSizeToUse + 'px ' + fontStyle
          ctx.fillStyle = color

          //Draw text in center
          ctx.fillText(txt, centerX, centerY)
        }
      }
    })

    this.options.elements.center.text = `${this.total}\nUnits`
    this.renderChart(this.chartData, this.options)
  }
}
